import { modifier } from 'ember-modifier';

// {{on-keydown 'Escape' this.someFunction}}
export default modifier(function onEnter(element, [eventKey, action]) {
  let handler = generateOnKeyDownHandler(action, eventKey);
  element.addEventListener('keydown', handler);

  return () => {
    element.removeEventListener('keydown', handler);
  };
});

function generateOnKeyDownHandler(action, eventKey) {
  return (e) => {
    if (e.key === eventKey) {
      action(e);
    }
  };
}
